module.exports = __webpack_public_path__ + "static/media/upload.5ab46dd7.svg";